import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  AIPEmailBuilderAside,
  IButtonBlockOptions,
} from "@wlocalhost/ngx-email-builder";
import { CdkStepper } from "@angular/cdk/stepper";
import { tap } from "rxjs";
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from "@angular/cdk/drag-drop";
import { CustomBlockComponent } from "../blocks/custom-block/custom-blockcomponent";
import { SnippetBlockComponent } from "../blocks/snippet-block/snippet-block.component";
import { ToastrService } from "ngx-toastr";
import { PaginationBaseModel } from "src/app/shared/components/ag-grid/ag-grid.model";

@Component({
  selector: "tail-email-aside",
  templateUrl: "./email-aside.component.html",
  styleUrls: ["./email-aside.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailAsideComponent
  extends AIPEmailBuilderAside
  implements OnInit
{
  @ViewChild(CdkStepper, { static: true })
  readonly stepper!: CdkStepper;
  toaster = inject(ToastrService);
  currentSettings$ = this.builderUiService.currentSettingsPortal$.pipe(
    // skip(1),
    tap(() => (this.stepper.selectedIndex = 2))
  );
  // snippetList = ['snippet 1','snippet 2','snippet 3','snippet 4','snippet 5','snippet 6',]
  options: IButtonBlockOptions = {
    backgroundColor: "#414141",
    border: {
      color: "#414141",
      style: "solid",
      sizes: {
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
      },
      width: 0,
      radius: 3,
    },
    color: "#ffffff",
    font: {
      fallback: "Arial, Helvetica, sans-serif",
      family: "Roboto",
      size: 13,
      style: "normal",
      weight: 400,
    },

    align: "center",
    fullWidth: false,
    // verticalAlign: 'middle',
    lineHeight: {
      value: 120,
      unit: "%",
    },
    link: {
      href: "",
      target: "_blank",
    },
    innerPadding: {
      top: 10,
      right: 25,
      bottom: 10,
      left: 25,
    },
    padding: {
      top: 10,
      right: 25,
      bottom: 10,
      left: 25,
    },
  };

  paginationBaseModel = new PaginationBaseModel();

  @HostBinding("class.relative") isReadonly(): boolean {
    return this.readonly;
  }
  override customBlocks: IIPEmailBuilderBlockData[] = [
    {
      title: "Custom Block 1",
      innerText: "Custom Block 1",
      id: "1",
      block: CustomBlockComponent,
      type: "button",
      state: true,
      data: [],
      options: this.options,
    },
    {
      title: "Custom Block 2",
      innerText: "Custom Block 2",
      id: "2",
      block: CustomBlockComponent,
      type: "button",
      state: true,
      data: [],
      options: this.options,
    },
    {
      title: "Custom Block 3",
      innerText: "Custom Block 3",
      id: "3",
      block: CustomBlockComponent,
      type: "button",
      state: true,
      data: [],
      options: this.options,
    },
  ];
  handleButtonClick(block: IIPEmailBuilderBlockData) {
    console.log("Block clicked:", block);
    console.log("Array data:", block.data);
  }

  onBlockDrop(event: CdkDragDrop<IIPEmailBuilderBlockData[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }
  onDrop(event: CdkDragDrop<any[]>) {
    const previousIndex = this.structures.findIndex(
      (structure) => structure === event.item.data
    );
    moveItemInArray(this.structures, previousIndex, event.currentIndex);
  }
  onDragStart(event: DragEvent, block: string) {
    const htmlContent = `<b>{{${block}}}</b>`;
    event.dataTransfer?.setData("text/html", htmlContent);
    // event.dataTransfer?.setData('text', `{{${block}}}`);
  }
  copy(text: string) {
    navigator.clipboard.writeText(text);
    this.toaster.success("Copied to clipboard.");
  }
  onPageChanged(pageNo: number) {
   this.page = pageNo;
   this.getAllSnippetlist()
  }
}
export interface IIPEmailBuilderBlockData {
  title: string;
  id: string;
  block: any;
  type: string;
  state: any;
  data: any[];
  innerText: any;
  options: any;
}
